function registerPickSource(scene, entity, load) {
  const source = { entity, load };
  scene._pickSources.push(source);
  return () => {
    const i = scene._pickSources.indexOf(source);
    if (i >= 0) {
      scene._pickSources.splice(i, 1);
    }
  };
}

export { registerPickSource };
//# sourceMappingURL=pick-contributor.js.map
